const DEFAULT_ENDPOINT = 'https://www.summalytics.ai/api/ingest';
const DEFAULT_WRITE_KEY = 'smly_Qtt0xAsdVgvb0QQiqL9QQFgs';

export const summalyticsConfig = {
  writeKey: process.env.GATSBY_SUMMALYTICS_WRITE_KEY || DEFAULT_WRITE_KEY,
  endpoint: process.env.GATSBY_SUMMALYTICS_ENDPOINT || DEFAULT_ENDPOINT,
  autoPageview: false,
};
